import React from 'react';
import ReactStrapTable from 'components/reactStrapTable';
import { dateFormate, cellRendererCheck } from 'utils/columns';

const columns = [
    {
        dataField: 'tpa',
        text: 'TPA',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      },
      {
        dataField: 'inboundOutbound',
        text: 'Inbound/Outbound',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      },
      {
        dataField: 'uploadStatus',
        text: 'Upload Status',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      },
      {
        dataField: 'uploadRetry',
        text: 'Upload Retry',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      },
      {
        dataField: 'fileType',
        text: 'File Type',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      },
      {
        dataField: 'fileName',
        text: 'File Name',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      },
      {
        dataField: 'recordCount',
        text: 'Record Count',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      },
      {
        dataField: 'createdDate',
        text: 'Created Date',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => dateFormate(rowData[col.dataField]),
      },
      {
        dataField: 'modifiedDate',
        text: 'Modified Date and Time',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => dateFormate(rowData[col.dataField]),
      },
      {
        dataField: 'fileID',
        text: 'File ID',
        sort: true,
        width: 140,
        show: true,
        inputType: 'text',
        cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      },
]

const FileTable = ({loading, data, pageSize, currentPage,records,onPageChange,onPageSizeChange}) => {
    return (
        <div
        className="table-card scroll-table position-relative border-0 rounded pt-0"
    fixed-height={data.length > 0 ? 'fixed-height' : 'default'}
    >
        <ReactStrapTable
        id={'reportsTable'}
        hasPagination
        loading={loading}
        data={data}
        columns={columns}
        onExport={() => ''}
        pageSize={pageSize}
        currentPage={currentPage}
        totalRecords={records}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
        />
    </div>
     )
}

export default FileTable